import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { workoutApi } from '../services/api';

export default function WorkoutsManagePage() {
  const { user } = useAuth();
  const [workouts, setWorkouts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [msg, setMsg] = useState('');

  const load = async () => {
    try {
      const r = await workoutApi.getAll();
      setWorkouts(Array.isArray(r.data) ? r.data : []);
    } catch (e) {
      console.error(e);
      setMsg('Erro ao carregar treinos');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    setMsg('');
    if (!name.trim()) return;
    try {
      await workoutApi.create({ name: name.trim(), description: description.trim() || undefined });
      setName('');
      setDescription('');
      await load();
      setMsg('Treino criado.');
    } catch {
      setMsg('Erro ao criar treino');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Remover este treino da tua conta?')) return;
    setMsg('');
    try {
      await workoutApi.delete(id);
      await load();
    } catch {
      setMsg('Erro ao remover');
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[40vh]">
        <div className="h-12 w-12 animate-spin rounded-full border-2 border-iron-border border-t-iron-accent" />
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h1 className="font-display text-4xl tracking-wider text-iron-accent">Treinos</h1>
        <p className="mt-2 font-mono text-xs uppercase tracking-widest text-iron-muted">
          Lista · criar · remover
        </p>
      </div>

      {msg && (
        <div className="rounded-xl border border-iron-border bg-iron-surface px-4 py-2 font-mono text-xs text-iron-muted">
          {msg}
        </div>
      )}

      <div className="card space-y-4">
        <h2 className="section-label">Novo treino</h2>
        <form onSubmit={handleCreate} className="space-y-3">
          <div>
            <label className="section-label mb-1 block">Nome</label>
            <input
              className="input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Ex.: Full body A"
              required
            />
          </div>
          <div>
            <label className="section-label mb-1 block">Descrição (opcional)</label>
            <textarea
              className="input min-h-[72px] resize-y"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <button type="submit" className="btn-primary w-full py-2">
            Criar
          </button>
        </form>
      </div>

      <div className="space-y-3">
        <h2 className="section-label px-1">Os teus treinos</h2>
        {workouts.length === 0 && (
          <p className="font-mono text-xs text-iron-muted px-1">Nenhum treino ainda.</p>
        )}
        {workouts.map((w) => (
          <div
            key={w.id}
            className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-iron-border bg-iron-card px-4 py-3"
          >
            <div className="min-w-0">
              <div className="font-display text-lg text-iron-text">{w.name}</div>
              {w.slug && (
                <span className="font-mono text-[9px] uppercase text-iron-accent">{w.slug}</span>
              )}
              {w.description && (
                <p className="mt-1 font-mono text-[10px] text-iron-muted line-clamp-2">{w.description}</p>
              )}
              <div className="mt-1 font-mono text-[10px] text-iron-muted">
                {(w.exercises || []).length} exercícios
              </div>
            </div>
            <div className="flex gap-2">
              <Link
                to="/workout"
                onClick={() => {
                  if (user?.id) {
                    sessionStorage.setItem(
                      'iron_active_workout_id',
                      JSON.stringify({ userId: String(user.id), workoutId: String(w.id) })
                    );
                  }
                }}
                className="btn-secondary px-3 py-1.5 font-mono text-[10px]"
              >
                Usar
              </Link>
              <button
                type="button"
                onClick={() => handleDelete(w.id)}
                className="rounded-lg border border-iron-danger/50 px-3 py-1.5 font-mono text-[10px] text-iron-danger hover:bg-iron-danger/10"
              >
                Apagar
              </button>
            </div>
          </div>
        ))}
      </div>

      <p className="text-center font-mono text-[10px] text-iron-muted">
        Os treinos base (PUSH / PULL / LEGS) são criados automaticamente.
      </p>
    </div>
  );
}
